import React, { forwardRef } from "react";
import { Text } from "@pixi/react";
import { TextStyle } from "pixi.js";
import { useTranslation } from "react-i18next";
import { useDimensions } from "../../../../Contexts/DimensionsContext";
import { TEXT_BUTTON_CONFIG, FONT_CONFIG } from "../../../../textureConfigs";

const PixiTextButton = forwardRef(
  (
    {
      text,
      translationKey,
      baseFontSize = 36,
      y = 0,
      x = 0,
      uppercase = false,
      fillColor,
      dropShadowColor,
      dropShadowDistance = 5,
      dropShadowBlur = 4,
      dropShadowAlpha = 1,
    },
    ref
  ) => {
    const { t } = useTranslation();
    const { uiSymbolHeight, getResponsiveConfig, uiSymbolScale } =
      useDimensions();

    // Use translation if translationKey is provided, otherwise use text prop
    let displayText = translationKey ? t(translationKey) : text;

    // Apply uppercase transformation if requested
    if (uppercase) {
      displayText = displayText.toUpperCase();
    }

    // Get text config with all multipliers
    const textConfig = getResponsiveConfig(TEXT_BUTTON_CONFIG);

    // Calculate final font size using multiplier from config
    const responsiveFontSize = baseFontSize * textConfig.fontSizeMultiplier;
    const FONT_SIZE = Math.round(responsiveFontSize * uiSymbolScale);

    const textY = Math.round(y - uiSymbolHeight * textConfig.yOffsetMultiplier);
    const textX = Math.round(x);

    // Text style - fonts are guaranteed to be loaded before this component renders
    const textStyle = new TextStyle({
      fontFamily: FONT_CONFIG.PRIMARY,
      fontSize: FONT_SIZE,
      fontWeight: "600",
      fill: fillColor || 0xffffff,
      ...(dropShadowColor && {
        dropShadow: true,
        dropShadowColor: dropShadowColor,
        dropShadowDistance: dropShadowDistance,
        dropShadowBlur: dropShadowBlur,
        dropShadowAlpha: dropShadowAlpha,
        dropShadowAngle: Math.PI / 2,
      }),
      align: "center",
    });

    return (
      <Text
        ref={ref}
        name="primary_text_button"
        text={displayText}
        style={textStyle}
        anchor={0.5}
        x={textX}
        y={textY}
        resolution={2}
        eventMode="none"
      />
    );
  }
);

PixiTextButton.displayName = "PixiTextButton";

export default PixiTextButton;
